export default __webpack_public_path__ + "static/media/aves.9ae40070.png";